<template>
  <div class="section" v-if="products.length">
    <h1 class="section-title"><span>检测项目</span></h1>
    <p class="section-tips">Testing Items</p>
    <div class="section-content">
      <div
        class="item pointer"
        :class="{ isRight: (index + 1) % 4 == 0 }"
        v-for="(item, index) in products"
        :key="index"
        @click="abilityClick(item)"
      >
        <img
          class="item-img"
          :src="item.abilityImage || $oss('common/empty-img.png')"
        />
        <div class="item-desc">
          <div class="item-name ellipsis">{{ item.abilityName }}</div>
          <div class="item-brief">{{ item.laboratoryAbilityTypeName }}</div>
        </div>
      </div>
    </div>
    <!-- 分页-->
    <Pagination
      :total="totalItem"
      :page="page"
      v-show="totalItem"
      @pageIndexChange="handlePageChange"
    />
  </div>
</template>
<script>
import { labCheckProjects } from "@/api/lab";
import Pagination from "@/components/Pagination/index";
export default {
  name: "hotService",
  components: {
    Pagination,
  },
  data() {
    return {
      products: [],
      loading: true,
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      totalItem: 0,
    };
  },
  created() {
    this.toSearch();
  },
  methods: {
    toDetailPage(item) {
      this.$jump.push({
        name: "checkProjectDetail",
        query: { id: item.laboratoryAbilityId },
      });
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.toSearch();
    },
    async toSearch() {
      this.loading = true;
      const { list, totalItem } = await this.$axios
        .post(labCheckProjects, {
          laboratoryId: this.$route.query.id,
          ...this.page,
        })
        .finally(() => {
          this.loading = false;
        });

      this.products = list;
      this.totalItem = totalItem;
    },
    abilityClick(data) {
      this.$router.push({
        name: "checkProjectDetail",
        query: { id: data.laboratoryAbilityId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.section {
  min-height: 500px;
  &-content {
    display: grid;
    grid-template-columns: repeat(4, 293px);
    gap: 15px;
    margin-bottom: 30px;
  }
}
.item {
  border: 1px solid #eeeff1;
  width: 293px;
  &-img {
    width: 100%;
    height: 222px;
    object-fit: cover;
  }
  &-desc {
    padding: 16px;
    background: white;
    text-align: center;
  }
  &-name {
    font-weight: bold;
    color: #333333;
    margin-bottom: 4px;
    font-size: 16px;
  }
  &-brief {
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
